<template>
  <div class="nav-top-wrapper">
    <div class="nav-view">
      <!-- 左侧：返回按钮（可选） -->
      <div class="nav-left">
        <div class="btn-back" @click="onBack" v-if="type == 1">
          <el-icon class="icon">
            <arrow-left />
          </el-icon>
          <div>返回</div>
        </div>
      </div>
      
      <!-- 中间：标题 -->
      <div class="nav-center">
        <div class="title">{{ title }}</div>
      </div>
      
      <!-- 右侧：插槽内容 -->
      <div class="nav-right">
        <slot></slot>
      </div>
    </div>
    <div class="line" v-if="line != 0"></div>
  </div>
</template>

<script>
export default {
  name: 'NavTop',
  props: {
    title:{
      type:String,
      default:"",
    },
    type:{
      type:Number,
      default:0,
    },
    line:{
      type:Number,
      default:1,
    },
  },
  mounted() {
    // console.warn(">>>>>>>>>>>>>>>",this.type)
  },
  data () {
    return {
    }
  },
  methods : {
    onBack()
    {
      // 发射返回事件，让父组件处理
      this.$emit('back')
      // 延迟执行返回，给父组件时间处理
      setTimeout(() => {
        window.history.back();
      }, 10)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nav-top-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-shrink: 0;
  background-color: #ffffff;
  /* Sticky positioning for safe area handling */
  position: sticky;
  top: 0;
  z-index: 999;
  padding-top: env(safe-area-inset-top);
}

.nav-view {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 1.8rem;
  box-sizing: border-box;
  background-color: #ffffff;
  flex-shrink: 0;
  // 处理左右安全区域
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
}

.nav-left {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 3rem;
  flex-shrink: 0;
  padding-left: 0.5rem;
}

.nav-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0; // 允许标题在空间不足时被截断
  padding: 0 0.5rem;
}

.nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-width: 3rem;
  flex-shrink: 0;
  padding-right: 0.5rem;
}

.title {
  font-size: 0.85rem;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.line {
  height: 1px;
  background-color: gray;
  width: 100%;
  flex-shrink: 0;
}

.btn-back {
  color: #1171ff;
  line-height: 1.3rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: start;
  flex-shrink: 0;
  white-space: nowrap;
  gap: 0.2rem;
}

</style>
